import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { neverReached as e } from "../../../core/compilerUtils.js";
import { isNone as t } from "../../../core/maybe.js";
import { getGeometryZScaler as r } from "../../../geometry/support/zscale.js";
import { unquantizeOptimizedGeometry as s, convertToGeometry as o } from "../../../layers/graphics/featureConversionUtils.js";

function i(e, t) {
  return t;
}

function n(e, t, r, s) {
  switch (r) {
    case 0:
      return d(e, t + s, 0);

    case 1:
      return "lowerLeft" === e.originPosition ? d(e, t + s, 1) : l(e, t + s, 1);
  }
}

function a(e, t, r, s) {
  return 2 === r ? d(e, t, 2) : n(e, t, r, s);
}

function h(e, t, r, s) {
  return 2 === r ? d(e, t, 3) : n(e, t, r, s);
}

function u(e, t, r, s) {
  return 3 === r ? d(e, t, 3) : a(e, t, r, s);
}

function d(_ref, r, s) {
  var e = _ref.translate,
      t = _ref.scale;
  return e[s] + r * t[s];
}

function l(_ref2, r, s) {
  var e = _ref2.translate,
      t = _ref2.scale;
  return e[s] - r * t[s];
}

var c = /*#__PURE__*/function () {
  function c(e) {
    _classCallCheck(this, c);

    this.options = e, this.geometryTypes = ["esriGeometryPoint", "esriGeometryMultipoint", "esriGeometryPolyline", "esriGeometryPolygon"], this.previousCoordinate = [0, 0], this.transform = null, this.applyTransform = i, this.lengths = [], this.currentLengthIndex = 0, this.toAddInCurrentPath = 0, this.vertexDimension = 0, this.coordinateBuffer = null, this.coordinateBufferPtr = 0, this.AttributesConstructor = function () {};
  }

  _createClass(c, [{
    key: "createFeatureResult",
    value: function createFeatureResult() {
      return {
        fields: [],
        features: []
      };
    }
  }, {
    key: "finishFeatureResult",
    value: function finishFeatureResult(e) {
      if (this.options.applyTransform && (e.transform = null), this.AttributesConstructor = function () {}, this.coordinateBuffer = null, this.lengths.length = 0, !e.hasZ) return;
      var s = r(e.geometryType, this.options.sourceSpatialReference, e.spatialReference);

      if (!t(s)) {
        var _iterator = _createForOfIteratorHelper(e.features),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t = _step.value;
            s(_t.geometry);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "createSpatialReference",
    value: function createSpatialReference() {
      return {};
    }
  }, {
    key: "addField",
    value: function addField(e, t) {
      e.fields.push(t);
      var r = e.fields.map(function (e) {
        return e.name;
      });

      this.AttributesConstructor = function () {
        var _iterator2 = _createForOfIteratorHelper(r),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _e = _step2.value;
            this[_e] = null;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };
    }
  }, {
    key: "addFeature",
    value: function addFeature(e, t) {
      e.features.push(t);
    }
  }, {
    key: "prepareFeatures",
    value: function prepareFeatures(t) {
      var _this = this;

      switch (this.transform = t.transform, this.options.applyTransform && t.transform && (this.applyTransform = this.deriveApplyTransform(t)), this.vertexDimension = 2, t.hasZ && this.vertexDimension++, t.hasM && this.vertexDimension++, t.geometryType) {
        case "esriGeometryPoint":
          this.addCoordinate = function (e, t, r) {
            return _this.addCoordinatePoint(e, t, r);
          }, this.createGeometry = function (e) {
            return _this.createPointGeometry(e);
          };
          break;

        case "esriGeometryPolygon":
          this.addCoordinate = function (e, t, r) {
            return _this.addCoordinatePolygon(e, t, r);
          }, this.createGeometry = function (e) {
            return _this.createPolygonGeometry(e);
          };
          break;

        case "esriGeometryPolyline":
          this.addCoordinate = function (e, t, r) {
            return _this.addCoordinatePolyline(e, t, r);
          }, this.createGeometry = function (e) {
            return _this.createPolylineGeometry(e);
          };
          break;

        case "esriGeometryMultipoint":
          this.addCoordinate = function (e, t, r) {
            return _this.addCoordinateMultipoint(e, t, r);
          }, this.createGeometry = function (e) {
            return _this.createMultipointGeometry(e);
          };
          break;

        default:
          e(t.geometryType);
      }
    }
  }, {
    key: "createFeature",
    value: function createFeature() {
      return this.lengths.length = 0, this.currentLengthIndex = 0, this.previousCoordinate[0] = 0, this.previousCoordinate[1] = 0, this.coordinateBuffer = null, this.coordinateBufferPtr = 0, {
        attributes: new this.AttributesConstructor()
      };
    }
  }, {
    key: "allocateCoordinates",
    value: function allocateCoordinates() {}
  }, {
    key: "addLength",
    value: function addLength(e, t, r) {
      0 === this.lengths.length && (this.toAddInCurrentPath = t), this.lengths.push(t);
    }
  }, {
    key: "addQueryGeometry",
    value: function addQueryGeometry(e, t) {
      var r = t.queryGeometry,
          i = t.queryGeometryType,
          n = s(r.clone(), r, !1, !1, this.transform),
          a = o(n, i, !1, !1);
      e.queryGeometryType = i, e.queryGeometry = _objectSpread({}, a);
    }
  }, {
    key: "createPointGeometry",
    value: function createPointGeometry(e) {
      var t = {
        x: 0,
        y: 0,
        spatialReference: e.spatialReference
      };
      return e.hasZ && (t.z = 0), e.hasM && (t.m = 0), t;
    }
  }, {
    key: "addCoordinatePoint",
    value: function addCoordinatePoint(e, t, r) {
      switch (t = this.applyTransform(this.transform, t, r, 0), r) {
        case 0:
          e.x = t;
          break;

        case 1:
          e.y = t;
          break;

        case 2:
          "z" in e ? e.z = t : e.m = t;
          break;

        case 3:
          e.m = t;
      }
    }
  }, {
    key: "transformPathLikeValue",
    value: function transformPathLikeValue(e, t) {
      var r = 0;
      return t <= 1 && (r = this.previousCoordinate[t], this.previousCoordinate[t] += e), this.applyTransform(this.transform, e, t, r);
    }
  }, {
    key: "addCoordinatePolyline",
    value: function addCoordinatePolyline(e, t, r) {
      this.dehydratedAddPointsCoordinate(e.paths, t, r);
    }
  }, {
    key: "addCoordinatePolygon",
    value: function addCoordinatePolygon(e, t, r) {
      this.dehydratedAddPointsCoordinate(e.rings, t, r);
    }
  }, {
    key: "addCoordinateMultipoint",
    value: function addCoordinateMultipoint(e, t, r) {
      0 === r && e.points.push([]);
      var s = this.transformPathLikeValue(t, r);
      e.points[e.points.length - 1].push(s);
    }
  }, {
    key: "createPolygonGeometry",
    value: function createPolygonGeometry(e) {
      return {
        rings: [[]],
        spatialReference: e.spatialReference,
        hasZ: !!e.hasZ,
        hasM: !!e.hasM
      };
    }
  }, {
    key: "createPolylineGeometry",
    value: function createPolylineGeometry(e) {
      return {
        paths: [[]],
        spatialReference: e.spatialReference,
        hasZ: !!e.hasZ,
        hasM: !!e.hasM
      };
    }
  }, {
    key: "createMultipointGeometry",
    value: function createMultipointGeometry(e) {
      return {
        points: [],
        spatialReference: e.spatialReference,
        hasZ: !!e.hasZ,
        hasM: !!e.hasM
      };
    }
  }, {
    key: "dehydratedAddPointsCoordinate",
    value: function dehydratedAddPointsCoordinate(e, t, r) {
      0 === r && 0 == this.toAddInCurrentPath-- && (e.push([]), this.toAddInCurrentPath = this.lengths[++this.currentLengthIndex] - 1, this.previousCoordinate[0] = 0, this.previousCoordinate[1] = 0);
      var s = this.transformPathLikeValue(t, r),
          o = e[e.length - 1];
      0 === r && (this.coordinateBufferPtr = 0, this.coordinateBuffer = new Array(this.vertexDimension), o.push(this.coordinateBuffer)), this.coordinateBuffer[this.coordinateBufferPtr++] = s;
    }
  }, {
    key: "deriveApplyTransform",
    value: function deriveApplyTransform(e) {
      var t = e.hasZ,
          r = e.hasM;
      return t && r ? u : t ? a : r ? h : n;
    }
  }]);

  return c;
}();

export { c as JSONFeatureSetParserContext };